/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M9 4.5v6.75h6V4.5H9Zm-1.5 6.75h-6V4.5h6v6.75Zm-6 1.5v6.75h6v-6.75h-6ZM0 19.5c0 .8284.6716 1.5 1.5 1.5h21c.8284 0 1.5-.6716 1.5-1.5v-15c0-.8284-.6716-1.5-1.5-1.5h-21C.6716 3 0 3.6716 0 4.5v15Zm22.5-8.25h-6V4.5h6v6.75Zm-6 1.5v6.75h6v-6.75h-6Zm-1.5 0H9v6.75h6v-6.75Z"
    clipRule="evenodd"
  />,
  'Schedule'
);
